export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11752.3fe734fc.jpg";